import Button from 'mobily-ui-library/lib/components/composite/button/Button';
import IconButton from "mobily-ui-library/lib/components/composite/iconButton/IconButton";
import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import Input from 'mobily-ui-library/lib/components/primitive/input/Input';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GlobalContext } from '../../../context/GlobalContext';
import { Error, isEmpty, CheckResponse } from '../../Util/Util';
import { ExistingCustomerFinalResponse } from '../../Util/ExistingCustomerFinalResponse';
import { NewCustomerFinalResponse } from '../../Util/NewCustomerFinalResponse';

import { createOpportunityCombined } from '../../../api/apigeeApi';
import { auditOTP, resendOTP, salesAudit, validateOTP } from '../../../api/api';
import './OTPVerification.scss';

export interface Props {
    rtl: boolean;
    hashValue: string;
}

const win: any = window;

function OTPVerification({ rtl, hashValue }: Props) {
    const { t } = useTranslation();
    const [otpValue, setOtpValue] = useState('');
    const [error, setError] = useState<string>('')
    const [state, dispatch]: any = useContext(GlobalContext);
    const { existingCustomerData, newCustomerData, lang, userType, productType } = state;

    const dir = rtl ? "right" : "left";

    const productInformation = state.productInformationData.map((item: any) => {
        return {
            productName: item.productInformation.packageName.value,
            simQuantity: item.productInformation.quantity.value
        }
    });

    let existingMobileNumber: string = !isEmpty(existingCustomerData) && existingCustomerData.mobileNumber;
    let newCustMobileNumber: string = !isEmpty(newCustomerData) && newCustomerData.mobileNumber;

    const phoneNumber = state.userType === 'newcustomer' ? newCustMobileNumber : existingMobileNumber;

    const handleChange = (e: any) => {
        setError('')
        setOtpValue(e.target.value);
    }

    const handleSubmit = () => {
        const data = {
            otp: otpValue,
            hashCode: hashValue
        }

        if (otpValue.length !== 0) {
            dispatch({ type: 'LOADER', payload: { loading: true } })
            validateOTP(data)
                .then((res: any) => {
                    console.log(res.data, '-----')
                    if (res.data !== '') {
                        const objCheck = typeof (res.data);
                        const { errorMsg } = objCheck === 'object' ? CheckResponse(res.data.status, lang) : CheckResponse(res, lang);
                        if (errorMsg.length > 0) {
                            const code = objCheck === 'object' ? res.data.status.code : res.status;

                            if (code === 'MAPI-8022' || code === 'MAPI-400' || code === 'MAPI-8023') {
                                setError(errorMsg)
                            } else {
                                Error(errorMsg)
                            }
                            dispatch({ type: 'LOADER', payload: { loading: false } })
                        }
                        otpAudit('error')
                    } else {
                        dispatch({ type: 'LOADER', payload: { loading: false } })
                        otpAudit('success')
                    }
                })
        } else {
            setError(t('Verification_Error'))
        }
    }

    const callbackFunction = (finalResponse: any) => {
        setTimeout(() => {
            dispatch({ type: 'LOADER', payload: { loading: true } });
            createOpportunityCombined(finalResponse)
                .then((res:any) => {
                    if (res.status === 200) {
                        dispatch({ type: 'LOADER', payload: { loading: false } });
                        window.location = win['submit_order_thanku_url'];
                    } else {
                        dispatch({ type: 'LOADER', payload: { loading: false } });
                        dispatch({ type: 'ERROR_PAGE', payload: { page: t("Failed_to_submit") } })
                    }
                })
        }, 1000)
    }

    const otpAudit = (otpStatus: string) => {
        dispatch({ type: 'LOADER', payload: { loading: true } });
        auditOTP(hashValue)
            .then((res: any) => {
                if (res.status === 200) {
                    if (otpStatus === 'success') {

                        auditSales(res.data);
                        const finalResponse = state.userType === 'existingcustomer' ? ExistingCustomerFinalResponse(state) : NewCustomerFinalResponse(state);
                        console.log(finalResponse, 'finalResponse')
                        callbackFunction(finalResponse)
                    } else {
                        auditSales(res.data);
                    }
                }
                dispatch({ type: 'LOADER', payload: { loading: false } })
            }).catch(err => {
                console.log(err,'err')
                dispatch({ type: 'ERROR_PAGE', payload: { page: t("Failed_to_submit") } })
            })
    }

    const auditSales = (auditList: any) => {
        const accountNumber = state.userType === 'newcustomer' ? newCustomerData.crNumber : existingCustomerData.accountNumber
        const apName = state.userType === 'newcustomer' ? `${newCustomerData.firstName} ${newCustomerData.lastName}` : existingCustomerData.apName
        const email = state.userType === 'newcustomer' ? newCustomerData.email : existingCustomerData.email
        const mobileNumber = state.userType === 'newcustomer' ? newCustomerData.mobileNumber : existingCustomerData.mobileNumber
        console.log('ausit list', auditList)
        const date = auditList.date.split(' ')[0].split('-').reverse().join('/');
        const time = auditList.date.split(' ')[1].split('.')[0];

        const auditData = { ...auditList, CRID: accountNumber, MSISDN: mobileNumber, productInformation }
        console.log('ausit auditData', auditData)
        const data = {
            "companyCRID": accountNumber,
            "serviceNumber": `+${mobileNumber}`,
            "mobileNumber": `+${mobileNumber}`,
            "serviceName": "Digital Sales OTP Audit",
            "requestedChange": JSON.stringify(auditData),
            "source": "business > manage-orders > fast-track-orders",
            "emailID": email,
            "apName": apName,
            "date": date,
            "time": time
        }

        salesAudit(data)
            .then((res: any) => {
                if (res.status === 204) {
                    console.log('success');
                } else {
                    console.log('error');
                }
            });
    }

    const handleCancel = () => {
        dispatch({ type: 'OTP_VERIFICATION_DATA', payload: { values: '', page: userType === 'newcustomer' || ['Data', 'Voice'].includes(productType) ? t("Download_Attach") : t("Product_Information"), prevModalOpen: false, modalOpen: false } })
    }

    const handleResend = () => {
        setError('');
        setOtpValue('');
        dispatch({ type: 'LOADER', payload: { loading: true } })

        const data = {
            hashCode: hashValue,
            language: lang.toUpperCase(),
            "otpLength": "4",
            "isNumeric": "Y",
            "verification": "Mobile"
        }

        resendOTP(data)
            .then((res: any) => {
                if (res.status === 204) {
                    dispatch({ type: 'LOADER', payload: { loading: false } })
                } else {
                    const { errorMsg } = CheckResponse(res.data.status, lang);
                    Error(errorMsg)
                    dispatch({ type: 'LOADER', payload: { loading: false } })
                }
            })
    }

    return (
        <>
            <div className='otpVerification-backdrop' />
            <div className={`otpVerfication-container fontFamily-${dir}`}>
                <Typography className='otpVerfication-title' rtl={rtl}>{t('One_more_step')}</Typography>
                <Typography className='otpVerfication-desc sansFont' rtl={rtl}>
                    {t('Verificationcode_sent')} <span>{phoneNumber} </span> {t('Enter_code_below')}
                </Typography>
                <Input headingleft={t('Verification_code')} value={otpValue} width={305} maxLength={4} type={'inactive'} className={`otpVerfication-input ${error.length > 0 ? 'error' : 'normal'}`} rtl={false} onChange={handleChange} />
                {error.length > 0 && <Typography className="otp-errorMsg" rtl={rtl}>{error}</Typography>}
                <div className='Otp-didntRecieve-code'>
                    {rtl ? (
                        <>
                            <Typography className="otp-resend" rtl={rtl} onClick={handleResend} >{t('Resend_code')}</Typography>
                            <Typography className="otp-not" rtl={rtl}>{t('Didn’t_receive_code')}</Typography>
                        </>
                    ) : (
                        <>
                            <Typography className="otp-not" rtl={rtl}>{t('Didn’t_receive_code')}</Typography>
                            <Typography className="otp-resend" rtl={rtl} onClick={handleResend} >{t('Resend_code')}</Typography>
                        </>
                    )}
                </div>

                <div className='otp-button-group'>
                    <IconButton className='otp-submit' rtl={rtl} onClick={handleSubmit}>{t('Submit')}</IconButton>
                    <Button className='otp-cancel' primary={false} variant={'default'} rtl={rtl} onClick={handleCancel}>{t('Cancel')}</Button>
                </div>
            </div>
        </>
    )
}

export default OTPVerification